import {
  AddressElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { FormEvent, RefObject, useState } from "react";

interface IPaymentElementFormProps {
  formRef: RefObject<HTMLFormElement>;
  setInvalidForm: (formState: boolean) => void;
  onSubmit: (paymentMethodId: string) => void;
}

function PaymentElementForm({
  formRef,
  setInvalidForm,
  onSubmit,
}: IPaymentElementFormProps) {
  const stripe = useStripe();
  const elements = useElements();

  const [invalidPaymentForm, setInvalidPaymentForm] = useState(true);
  const [invalidAddressForm, setInvalidAddressForm] = useState(true);

  const [isPaymentLoading, setIsPaymentLoading] = useState(true);
  const [isAddressLoading, setIsAddressLoading] = useState(true);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    if (!stripe || !elements) return;

    e.preventDefault();

    confirmSetup();
  }

  async function confirmSetup() {
    if (!stripe || !elements) return null;

    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: "",
      },
    });

    if (error) {
      return;
    }

    if (setupIntent.payment_method && setupIntent.status === "succeeded") {
      onSubmit(setupIntent.payment_method.toString());
    }
  }

  return (
    <form onSubmit={handleSubmit} ref={formRef} className="w-full">
      <p className="h-4 text-slate-800 font-bold mb-4"> Payment details</p>
      <PaymentElement
        options={{
          layout: "tabs",
          terms: { card: "never" },
        }}
        onChange={(formStatus) => {
          setInvalidPaymentForm(!formStatus.complete);
          setInvalidForm(!formStatus.complete || invalidAddressForm);
        }}
      />
      <p className="h-4 text-slate-800 font-bold my-4">
        Cardholder billing information
      </p>
      <AddressElement
        options={{ mode: "billing" }}
        onChange={(formStatus) => {
          setInvalidAddressForm(!formStatus.complete);
          setInvalidForm(!formStatus.complete || invalidPaymentForm);
        }}
      />
    </form>
  );
}

export default PaymentElementForm;
